export default "__VITE_ASSET__CTg5wW8S__"